export default "Leg danner grobund for sjove oplevelser sammen, nye relationer og fællesskabsdannelse.";